import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { ENVIRONMENT } from '@cfp/core';
import { LoginCard } from '@cfp/shared/ui/login';
import { Button, Icon, InputText, Link } from '@cfp/ui';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PasswordService } from 'csr-login-app';
import { LoginLoadingSpinner, LoginMessages } from '../../components';
import { LoginFormService } from '../../services';

@Component({
  selector: 'cfp-forgot-password-page',
  templateUrl: './forgot-password-page.html',
  imports: [
    LoginCard,
    LoginLoadingSpinner,
    TranslateModule,
    LoginMessages,
    ReactiveFormsModule,
    InputText,
    Link,
    RouterLink,
    Button,
    Icon
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForgotPasswordPage {
  protected readonly isLoading = signal(false);
  protected readonly isFormSubmitSuccess = signal(false);
  protected readonly successMessages = signal<string[]>([]);
  protected readonly warningMessages = signal<string[]>([]);
  protected readonly errorMessages = signal<string[]>([]);

  protected locale: string;
  protected form: FormGroup;

  protected readonly environment = inject(ENVIRONMENT);
  private readonly loginFormService = inject(LoginFormService);
  private readonly fb = inject(FormBuilder);
  private readonly translateService = inject(TranslateService);
  private readonly passwordService = inject(PasswordService);

  constructor() {
    const group: any = {
      username: ['', Validators.required]
    };

    this.form = this.fb.group(group);

    this.locale = this.translateService.currentLang;
  }

  protected submitForm(): void {
    if (this.validateForm()) {
      this.isLoading.set(true);

      this.passwordService
        .v2PasswordForgotpasswordPost({
          username: this.form.value.username,
          environmentCode: this.environment.environmentCode.dto
        })
        .subscribe({
          next: () => {
            this.isLoading.set(false);
            this.successMessages.set(['login.success.requestPasswordReset']);
            this.isFormSubmitSuccess.set(true);
          },
          error: () => {
            this.isLoading.set(false);
          }
        });
    }
  }

  private validateForm(): boolean {
    if (this.form.status === 'INVALID') {
      this.errorMessages.set(this.loginFormService.transformErrorMessages(this.form));
      return false;
    } else {
      this.errorMessages.set([]);
      return true;
    }
  }
}
